import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="white_papers" pageTitle="Downloads" pageDescription="In-depth technical papers, guides, and readiness assessments on regulatory strategy, quality management, and compliance across the life sciences industry." />;

export const Route = createFileRoute("/en/downloads/")({
  head: () => buildRouteHead("/en/downloads"),
  component: ContentListingRoute,
});

